import jQuery from 'jquery';
import config from '../app-config';
import { makeRequest } from './request';

const Select = (function($){
    const select = $('.js-select');
    const selectAjax = $('.js-selectAjax');


    const selectricOptions = {
        arrowButtonMarkup: '<span class="select-button"></span>',
        maxHeight: 225,
        responsive: true,
    };

    /**
     * Set single select input
     */
    function setSingleSelect(select) {
        if (!config.mobile) {
            // if (!checkDataTableSelectric(select.get(0))) {
                select.selectric(selectricOptions);
            // }
        } else {
            select.addClass('is-raw');
        }
    }

    /**
     * Check if selected select element is connected with
     * DataTable. If dont initialize it here. Init will happen in datatables.js
     */
    function checkDataTableSelectric(select) {
        const id = select.id;
        return id.indexOf('listing_show_') > -1;
    }

    /**
     * Set multiselect input
     */
    function setMultiSelect(select) {
        const maxItems = parseInt(select.attr('data-max-items'), 10) || 1;
        const label = select.attr('data-label');

        const labelClass = select.hasClass('is-dark') ? 'class="is-dark"' : '';

        if (label) {
            if (!config.mobile) {
                select.prepend('<option value="">$(label)</option>');
            } else {
                select.addClass('is-raw');
                select.parent().prepend('<label for="' + select.attr() + '">$(label)</label>');
            }
        }

        if (!config.mobile) {
            select.selectize($.extend(selectizeOptions, {
                maxItems,
            }));
        }
    }

    /**
     * Set select input according to it's type
     */
    function setSelect() {
        $(document).find('select').each(function () {
            const select = ($(this)[ 0 ].nodeName.toLowerCase() === 'select') ? $(this) : $(this).find('select');
            if (typeof select.attr('multiple') !== 'undefined') {
                setMultiSelect(select);
            } else {
                setSingleSelect(select);
            }
        });

    }

    function setSelectsAjax() {
        selectAjax.selectric(
            $.extend({}, selectricOptions, {
                onBeforeOpen() {
                    const ajaxOptions = $(this).data('ajax');
                    const getData = makeRequest(ajaxOptions);

                    getData.then((response) => {
                        console.log(response.data);
                    });
                },
            })
        );
    }


    function setSelects() {
        if (!config.mobile) {
            select.selectric(selectricOptions);
        } else {
            select.addClass('is-raw');
        }
    }


    return {
        init: function() {
            if (select.length > 0) {
                setSelects();
            }

            if (select.length > 0) {
                setSelectsAjax();
            }
        }
    };


}(jQuery));

export { Select }


// WEBPACK FOOTER //
// ./src/_app/layout/select.js